/*globals jQuery */
( function() {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	// ACCESSIBLE EXPAND/COLLAPSE SECTIONS
	// Add data-expanded to target to trigger expanded by default
	window.MSR.expandCollapse = ( function( $, undefined ) {
		var config;

		var init = function( settings ) {
			config = {
				target: '.msr-expandable-section'
			};

			$.extend( config, settings );

			setup();
		};

		var setup = function() {
			$( config.target ).each( function( i, el ){
				var heading = $( el ),
					content = heading.next(),
					expanded = heading.data( 'expanded' );

				console.log( heading.data( 'expanded' ) );

				//wrap content in a container, mostly to help with styling (ex. the border below the content while hidden)
				var container = $( '<div class="msr-expandable-container"></div>' );
				$( content ).wrap( container );

				//wrap the heading in a button
				heading.wrapInner( '<a href="#" role="button" data-bi-name="dnt button" data-bi-dnt></a>' );
				var trigger = heading.children().eq( 0 );

				heading.addClass( 'msr-expandable-header' );

				trigger.attr( 'aria-haspopup', 'true' );
				content.addClass( 'msr-expandable-content' );

				// Check if should be expanded by default.
				if ( undefined !== expanded ) {
					trigger.attr( 'aria-expanded', 'true' );
					content.attr( 'aria-hidden', 'false' );
				} else {
					trigger.attr( 'aria-expanded', 'false' );
					content.attr( 'aria-hidden', 'true' );
				}

				trigger.on( 'click', function( e ){
					e.preventDefault();
					var ae = ( trigger.attr( 'aria-expanded' ) === 'true' ) ? 'false' : 'true';
					var ah = ( content.attr( 'aria-hidden' ) === 'true' ) ? 'false' : 'true';
					trigger.attr( 'aria-expanded', ae );
					content.attr( 'aria-hidden', ah );

					//trigger bi events
					if ( ae === 'true' ) {
						window.MSR.wedecsBi.sendCustomEvent( this, {
							'ms.interactionType': 14
						} );
					} else {
						window.MSR.wedecsBi.sendCustomEvent( this, {
							'ms.interactionType': 15
						} );
					}
				} );
			} );
		};

		return {
			init: init
		};
	} )( jQuery );
} )();
